<template>
  <section class="redemptions">
    <div class="modal" v-if="openModal" id="rastreio">
      <div class="modal__title">
        <h2>Detalhes do Rastreio</h2>
        <i class="fas fa-times" @click="openModal = false"></i>
      </div>
      <div class="modal__body">
        <textarea
          name="infosRastreio"
          id="infosRastreio"
          cols="30"
          rows="10"
        ></textarea>
      </div>
      <div class="modal__footer">
        <button>SALVAR</button>
      </div>
    </div>
    <div class="table" style="overflow-x: auto">
      <div class="search">
        <input
          type="search"
          id="inputSearch"
          @keyup="buscarParceiro"
          placeholder="Buscar pelo Tipo. Ex: Resgate de Produto"
        />
        <input
          type="date"
          placeholder="Buscar pela Data. Ex: 27/04"
          id="data"
          @keyup="buscarData"
        />
        <button @click="buscarData">Filtar por Data</button>
      </div>
      <div class="loader" v-if="loader">
        <span><i class="fas fa-stroopwafel fa-spin fa-3x"></i></span>
        <span>Aguarde, enquanto as informações de resgates carregam!</span>
      </div>
      <table id="table" v-if="!loader">
        <thead>
          <tr>
            <th>Data de Resgate</th>
            <th>CNPJ</th>
            <th>E-mail</th>
            <th>Tipo</th>
            <th>Quantidade</th>
            <th>Profitz</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(info, i) in infos" :key="i">
            <td style="width: 10%">
              {{ moment(info.createdAt).format("DD/MM/YYYY") }}
            </td>
            <td>{{ info.cnpj }}</td>
            <td>{{ info.email }}</td>
            <td>{{ info.description }}</td>
            <td>1</td>
            <td>{{ Math.round(info.value / 100) }}</td>
            <td>
              <a
                href="#rastreio"
                v-if="info.description.includes('Resgate do produto')"
                @click="openModal = !openModal"
              >
                Rastreio
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      openModal: false,
      infos: [],
      loader: false,
      dataInicio: null,
      dataFim: null,
    };
  },
  methods: {
    async getDados() {
      this.loader = true;
      try {
        const response = await axios.get(
          "https://api-bombou.herokuapp.com/extrato"
        );
        let info = response.data;
        let array = [];

        for (var i = 0; i < info.length; i++) {
          if (info[i].value < 0) {
            array.push(info[i]);
          }
        }

        this.infos = array;

        this.loader = false;
      } catch (error) {
        console.log(error);
      }
    },
    buscarParceiro() {
      let input, filter, table, tr, td, i, txtValue;
      input = document.getElementById("inputSearch");
      filter = input.value.toUpperCase();
      table = document.getElementById("table");
      tr = table.getElementsByTagName("tr");
      for (i = 0; i < tr.length; i++) {
        td = tr[i].getElementsByTagName("td")[3];

        if (td) {
          txtValue = td.textContent.toUpperCase() || td.innerText.toUpperCase();
          if (txtValue.indexOf(filter) > -1) {
            tr[i].style.display = "";
          } else {
            tr[i].style.display = "none";
          }
        }
      }
    },
    buscarData() {
      let input, filter, table, tr, td, i, txtValue;
      input = document.getElementById("data");
      filter = input.value.split("-").reverse().join("/");
      table = document.getElementById("table");
      tr = table.getElementsByTagName("tr");
      for (i = 0; i < tr.length; i++) {
        td = tr[i].getElementsByTagName("td")[0];

        if (td) {
          txtValue = td.textContent || td.innerText;
          if (txtValue.includes(filter)) {
            tr[i].style.display = "";
          } else {
            tr[i].style.display = "none";
          }
        }
      }
    },
  },

  beforeMount() {
    this.getDados();
  },
};
</script>

<style lang="scss" scoped>
.loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  padding-top: 50px;

  i {
    color: var(--customBlue);
    margin-top: 30px;
  }

  span:nth-child(2) {
    padding-top: 10px;
    font-size: 0.95rem;
  }
}

.redemptions {
  max-width: 90%;
  margin: 0 auto;
  padding-top: 50px;

  .modal {
    background: var(--customWhite);
    border: 1px solid var(--customGray-100);
    border-radius: 5px;
    padding: 15px;
    position: absolute;
    left: 50%;
    top: 0;
    z-index: 99999;
    transform: translate(-50%, 50%);
    width: 90%;

    @media (min-width: 441px) {
      width: 50%;
    }

    &__title {
      padding: 10px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      h2 {
        color: var(--standardGreen);
        font-size: 1.1rem;
      }

      i {
        color: rgb(173, 5, 5);
        font-size: 1.1rem;
        cursor: pointer;
      }
    }

    &__body {
      textarea {
        border: 1px solid var(--customGray-100);
        border-radius: 5px;
        margin: 10px 0;
        width: 100%;
        padding: 10px;
        resize: none;
        outline: none;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
      }
    }

    &__footer {
      button {
        background: var(--standardGreen);
        color: var(--customWhite);
        border-radius: 5px;
        padding: 8px;
        outline: none;
        font-size: 0.95rem;
        box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
          0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
        letter-spacing: 0.0492857143rem;
      }
    }
  }

  .search {
    padding-bottom: 30px;
    display: flex;
    flex-direction: column;

    @media (min-width: 441px) {
      flex-direction: row;
    }

    input {
      border-bottom: 1px solid var(--customGray-100);
      padding: 5px;
      outline: none;
      color: var(--customGray-500);
      transition: all 0.2s;
      width: 100%;
      margin: 10px 0;

      &:focus {
        border-bottom: 2px solid var(--customGray-800);
      }

      @media (min-width: 441px) {
        width: 27%;
        margin: 0 10px;
      }
    }

    button {
      background: var(--standardGreen);
      color: var(--customWhite);
      padding: 5px;
      border-radius: 5px;
    }
  }

  .table {
    table {
      width: 100%;
      border-collapse: collapse;
      border-spacing: 0;
      margin-top: 75px;

      @media (min-width: 441px) {
        margin-top: 0;
      }

      thead {
        tr {
          th {
            color: var(--customGray-500);
            padding: 5px 0;
            background: var(--customGray-70);
            font-size: 0.95rem;
          }
        }
      }

      tbody {
        tr {
          td {
            padding: 10px 20px;
            text-align: center;
            border-bottom: 1px solid var(--customGray-100);
            font-size: 0.95rem;
            color: var(--customGray-800);

            a {
              background: var(--standardGreen);
              color: var(--customWhite);
              border-radius: 5px;
              text-decoration: none;
              padding: 5px;
              outline: none;
              font-size: 0.95rem;
              box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
                0px 2px 2px 0px rgb(0 0 0 / 14%),
                0px 1px 5px 0px rgb(0 0 0 / 12%);
              letter-spacing: 0.0492857143rem;
            }
          }
        }
      }
    }
  }
}
</style>